import { AsyncOperationsModel } from "../../utility/AsyncOperationsModel";
import { observable, action } from "mobx";
import { IRole, IGroup, IUser, IOrganisation } from "../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { observer } from "mobx-react";
import BaseComponent from "../../utility/BaseComponent";
import UserDetailsForm, { UserDetailsFormModel } from "../UserDetailsForm/UserDetailsForm";
import { IServicesProvider } from "../../di/IServicesProvider";
import * as React from "react";
import { DialogContainer, CircularProgress, Card, CardText } from "react-md";
import "./static/AddUserDialog.scss";
export class AddUserDialogModel extends AsyncOperationsModel {
    @observable roles: IRole[];
    @observable groups: IGroup[];
    @observable user: IUser;
    @observable showDialog: boolean = false;
    @observable onCompleted: Function;
    @observable userDetailsModel: UserDetailsFormModel;
    @observable servicesProvider: IServicesProvider;
    private organisationCode: string;
    constructor(servicesProvider: IServicesProvider, organisationCode: string, onCompleted: Function) {
        super();
        this.servicesProvider = servicesProvider;
        this.organisationCode = organisationCode;
        this.onCompleted = onCompleted;
        this.userDetailsModel =  new UserDetailsFormModel(
            this.servicesProvider.getInputValidator(),
            this.groups,
            this.roles,
            this.organisationCode);
    }

    @action.bound
    setUser(user?: IUser) {
        this.user = user;
        this.userDetailsModel.setOriginalUser(this.user);
    }
    
    @action.bound
    setShowDialog(showDialog: boolean) {
        this.showDialog = showDialog;
    }
    
    @action.bound
    resetAsyncOperationsCount() {
        this.asyncOperationsCount = 0;
    }
    @action.bound
    setRoles(organisation: IOrganisation) {
        if (!isNullOrUndefined(organisation.roles)) {
            this.roles = organisation.roles;
            this.userDetailsModel.setRoles(this.roles);

        }
    }
    @action.bound
    setGroups(organisation: IOrganisation) {
        if (!isNullOrUndefined(organisation.groups)) {
            this.groups = organisation.groups;
            this.userDetailsModel.setGroups(this.groups);

        }
    }
    @action.bound
    prepare() {
        let adminApi = this.servicesProvider.getAdminServicesProvider().getUsersControls().getOperations().getApi();
        this.resetAsyncOperationsCount();
        adminApi.getOrganisationDetails(this.organisationCode)
        .first()
        .subscribe(
            result => {
                this.resetAsyncOperationsCount();
                this.setRoles(result);
                this.setGroups(result);
            },
            error => {
                this.resetAsyncOperationsCount();
                this.setErrorMessages(error.message);
            }
        );
    }
    @action.bound
    hideDialog() {
        this.userDetailsModel.setOriginalUser(undefined);
        this.onCompleted(true);
    }
    @action.bound
    executeAddUser() {
        let userDetails = this.userDetailsModel.getUser();
        this.incrementAsyncOperations();
        this.servicesProvider
            .getAdminServicesProvider()
            .getUsersControls()
            .getOperations()
            .addUsers(this.organisationCode,
                      [
            {
                name: userDetails.name,
                password: userDetails.password,
                confirmPassword: userDetails.password,
                role: isNullOrUndefined(userDetails.role) ? "" : userDetails.role.id,
                group: userDetails.groups[0].id,
                username: userDetails.username.replace(`${this.organisationCode.toUpperCase()}-`, ""),
                organisation_code: this.organisationCode.toUpperCase(),
                email_address: userDetails.email,
                organisation_id: this.servicesProvider.getUser().organisation_id,
                is_admin: userDetails.is_admin,
                autoApprove: userDetails.status === 1,
                accessCode: ""
            }]
        )
        .first()
        .subscribe(
            () => {
                this.resetAsyncOperationsCount();
                this.onCompleted(false);
            },
            error => {
                this.resetAsyncOperationsCount();
                this.setErrorMessages([error.message]);
            }
        );
    }
    @action.bound
    executeEditUser() {
        this.incrementAsyncOperations();
        this.servicesProvider
        .getAdminServicesProvider()
        .getUsersControls()
        .getOperations()
        .editUsers([this.userDetailsModel.getUser()])
        .subscribe(
            result => {
                this.resetAsyncOperationsCount();
                this.onCompleted(false);
            },
            error => {
                this.resetAsyncOperationsCount();
                this.setErrorMessages([error.message]);
            }
        );
    }
    @action.bound
    onConfirmClicked() {
        if (isNullOrUndefined(this.user)) {
            this.executeAddUser();
        } else {
            this.executeEditUser();
        }
    }
    
} 
@observer class AddUserDialog extends BaseComponent<{ model: AddUserDialogModel }, {}> {
    
    render() {
        return (
            <DialogContainer
                
                dialogClassName="AddUserDialog"
                id="AddUserDialog"
                visible={this.props.model.showDialog}
                title={isNullOrUndefined(this.props.model.user) ? "Add User" : "Edit User"}
                modal={true}
                actions={[
                    {
                        onClick: this.props.model.onConfirmClicked,
                        secondary: true,
                        children: "Confirm",
                        disabled: !this.props.model.userDetailsModel.saveEnabled
                    },
                    {
                        onClick: this.props.model.hideDialog,
                        secondary: true,
                        children: "Cancel"
                    }
                ]}
            >
            {           this.props.model.asyncOperationsCount === 0 && 
                        this.props.model.errorMessages.length > 0 &&
                        <Card className="messagesCard">
                            <CardText className="messageText">
                                {
                                    this.props.model.errorMessages.map(
                                        (item, index) => {
                                            return <p key={index}>{item}</p>;
                                        }
                                    )
                                }
                            </CardText>
                        </Card>
                    }
            {
                this.props.model.asyncOperationsCount > 0 && 
                <CircularProgress id="progress" centered={true}/>
            }
            {
                this.props.model.asyncOperationsCount === 0 && 
                !isNullOrUndefined(this.props.model.roles) &&
                !isNullOrUndefined(this.props.model.groups) &&
             <UserDetailsForm model={this.props.model.userDetailsModel} />
            }
            </DialogContainer>
        );
    }
}
export default AddUserDialog;


// WEBPACK FOOTER //
// ./src/component/AddUserDialog/AddUserDialog.tsx